import { render, staticRenderFns } from "./ResponsesModal.vue?vue&type=template&id=679061b6"
import script from "./ResponsesModal.vue?vue&type=script&lang=js"
export * from "./ResponsesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports